import { Box, Button, Flex, Group, Text } from '@mantine/core';
import { IconHourglass } from '@tabler/icons-react';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type Props = {
  onContinue: () => void;
  disabled?: boolean;
};

export function ToolLimitReachedWidget({ onContinue, disabled }: Props) {
  return (
    <Box bg="orange.1" p="md" style={{ borderRadius: 'var(--mantine-radius-md)' }}>
      <Flex direction="column" gap="sm">
        <Group gap="xs" align="center">
          <IconHourglass size={16} stroke={1.5} color="var(--mantine-color-orange-7)" aria-hidden />
          <Text size="textSm" fw={FONT_WEIGHTS.semibold} c="gray.9">
            Siesta has hit the maximum amount of thinking for this turn
          </Text>
        </Group>
        <Text size="textSm" c="gray.8">
          If you would like Siesta to carry on, please press Continue.
        </Text>
        <Button
          variant="filled"
          color="orange"
          size="sm"
          onClick={onContinue}
          disabled={disabled}
          style={{ alignSelf: 'flex-start' }}
        >
          Continue
        </Button>
      </Flex>
    </Box>
  );
}
